module.exports = new __parcel__URL__("crystal-rainbow.3a68bf32.svg").toString();